import React from 'react';
import { Flex, Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { TAB_HEIGHT } from '@atlassian/jira-navigation-kit-common/src/index.tsx';

export const SkeletonComponent = () => (
	<Flex xcss={skeletonWrapperStyles}>
		<Box xcss={skeletonItemStyles} />
		<Box xcss={skeletonItemStyles} />
		<Box xcss={skeletonItemStyles} />
		<Box xcss={skeletonItemStyles} />
		<Box xcss={skeletonItemStyles} />
		<Box xcss={skeletonItemStyles} />
		<Box xcss={skeletonItemStyles} />
		<Box xcss={skeletonItemStyles} />
	</Flex>
);

const skeletonWrapperStyles = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
	height: `${TAB_HEIGHT}px`,
	gap: 'space.200',
	paddingInlineStart: 'space.300',
	paddingInlineEnd: 'space.300',
	paddingBlockStart: 'space.100',
	paddingBlockEnd: 'space.150',
	position: 'relative',
	'::after': {
		content: '""',
		position: 'absolute',
		bottom: '0',
		backgroundColor: 'color.skeleton',
		height: '2px',
		left: '0',
		right: '0',
	},
});

const skeletonItemStyles = xcss({
	minWidth: token('space.1000'),
	backgroundColor: 'color.skeleton',
	borderRadius: token('border.radius'),
});
